/* DOMO theme — main JS */
(function () {
  'use strict';

  // Mobile menu toggle
  const mobileToggle = document.getElementById('mobileMenuToggle');
  const mobileMenu = document.getElementById('mobileMenu');
  const mobileClose = document.getElementById('mobileMenuClose');

  function openMobileMenu() {
    mobileMenu?.classList.add('is-open');
    mobileMenu?.setAttribute('aria-hidden', 'false');
    mobileToggle?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    mobileMenu?.classList.remove('is-open');
    mobileMenu?.setAttribute('aria-hidden', 'true');
    mobileToggle?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  mobileToggle?.addEventListener('click', openMobileMenu);
  mobileClose?.addEventListener('click', closeMobileMenu);
  document.querySelectorAll('[data-mobile-link]').forEach(a => {
    // Let the link navigate normally — but close the menu first
    a.addEventListener('click', () => {
      // Slight delay to let the click navigate
      setTimeout(closeMobileMenu, 50);
    });
  });

  // Close mobile menu on Escape
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && mobileMenu?.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  // Hero slider
  const heroSlider = document.querySelector('[data-hero-slider]');
  if (heroSlider) {
    const slides = heroSlider.querySelectorAll('[data-slide]');
    const indicators = heroSlider.querySelectorAll('[data-indicator]');
    const interval = parseInt(heroSlider.dataset.interval || '6000', 10);

    if (slides.length > 1) {
      let active = 0;
      let timer;

      function goTo(i) {
        slides[active].classList.remove('is-active');
        indicators[active]?.classList.remove('is-active');
        active = (i + slides.length) % slides.length;
        slides[active].classList.add('is-active');
        indicators[active]?.classList.add('is-active');
      }

      function start() {
        clearInterval(timer);
        timer = setInterval(() => goTo(active + 1), interval);
      }

      indicators.forEach((d, i) => {
        d.addEventListener('click', () => { goTo(i); start(); });
      });

      heroSlider.addEventListener('mouseenter', () => clearInterval(timer));
      heroSlider.addEventListener('mouseleave', start);

      start();
    }
  }

  // Smooth scroll for in-page anchor jumps (menu categories)
  document.querySelectorAll('[data-jump]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById(link.dataset.jump);
      if (target) {
        const top = target.getBoundingClientRect().top + window.scrollY - 180;
        window.scrollTo({ top, behavior: 'smooth' });
        document.querySelectorAll('[data-jump]').forEach(l => l.classList.remove('is-active'));
        link.classList.add('is-active');
      }
    });
  });

  // Reveal-on-scroll
  if ('IntersectionObserver' in window) {
    const reveals = document.querySelectorAll('.reveal');
    if (reveals.length) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      reveals.forEach(el => io.observe(el));
    }
  } else {
    // Fallback: show everything immediately
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('is-visible'));
  }

  // Quantity steppers (used on cart and product pages)
  document.querySelectorAll('[data-qty-minus]').forEach(b => {
    b.addEventListener('click', () => {
      const input = b.parentElement.querySelector('input');
      if (input) {
        const min = parseInt(input.min || '0', 10);
        input.value = Math.max(min, parseInt(input.value, 10) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
  document.querySelectorAll('[data-qty-plus]').forEach(b => {
    b.addEventListener('click', () => {
      const input = b.parentElement.querySelector('input');
      if (input) {
        input.value = parseInt(input.value, 10) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

})();
